import React from 'react'
import PropTypes from 'prop-types'
import {useSelector} from 'react-redux'
import Tag from '#components/a/Tag'
import CopyAzubiModal from '#components/m/Versetzungsplan/CopyAzubiModal'
import Text from '#components/a/Text'
import {displayString} from '#tools/user'

function UserCell({userToDisplayInfo, hasDrafts, editAbteilungseinsaetze}) {
  const userId = useSelector(state => state.authentication.id)

  return (
    <div className="userName" data-testid="azubi-label">
      <div className="azubi-label-icons">
        {hasDrafts && <Tag name="Entwurf" variant="entwurf" />}
        <div className="azubi-label-icons--buttons">
          {editAbteilungseinsaetze && <CopyAzubiModal user={userToDisplayInfo} />}
        </div>
      </div>
      <Text text={displayString(userId, userToDisplayInfo)} modifier="dark" />
    </div>
  )
}

UserCell.propTypes = {
  userToDisplayInfo: PropTypes.shape({
    firstname: PropTypes.string,
    lastname: PropTypes.string,
    name: PropTypes.string,
    id: PropTypes.number,
  }),
  hasDrafts: PropTypes.bool,
  editAbteilungseinsaetze: PropTypes.bool,
}

export default UserCell
